import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_draw_participants: { message: "idle" },
};

export const retrieve_draw_participants_Slice = createSlice({
 name: "retrieve_draw_participants",
 initialState,
 reducers: {
  success_retrieve_draw_participants: (state, action) => {
   state.retrieve_draw_participants = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_draw_participants: (state, action) => {
   state.retrieve_draw_participants = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_draw_participants: (state) => {
   state.retrieve_draw_participants = { status: app_consts.IDLE };
  },
  loading_retrieve_draw_participants: (state) => {
   state.retrieve_draw_participants = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_draw_participants, fail_retrieve_draw_participants, reset_retrieve_draw_participants, loading_retrieve_draw_participants } = retrieve_draw_participants_Slice.actions;

export default retrieve_draw_participants_Slice.reducer;